import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { RestService } from 'src/app/services/rest.service';
import { HeaderComponent } from '../header/header.component';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnDestroy {
  searchName = '';
  results: any[] = [];
  isLoading = false;
  hasSearched = false;

  private query$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<HeaderComponent>,
    private rest: RestService,
    private router: Router
  ) {
    this.query$.pipe(
      debounceTime(350),
      distinctUntilChanged(),
      switchMap(q => {
        if (!q.trim()) {
          this.results = [];
          this.hasSearched = false;
          this.isLoading = false;
          return [];
        }
        this.isLoading = true;
        this.hasSearched = true;
        return this.rest.search(q);
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        const list = Array.isArray(res) ? res : [];
        list.forEach((p: any) => {
          if (p.images?.length) {
            p.images[0].image_url = `${environment.apiUrl}/images/?id=${p.images[0].image_url}`;
          }
        });
        this.results = list;
      },
      error: () => {
        this.isLoading = false;
        this.results = [];
      }
    });
  }

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    localStorage.setItem('searchText', value);
    this.query$.next(value);
  }

  effectivePrice(product: any): number {
    if (!product.discount || product.discount <= 0) return product.price;
    return Math.round(product.price * (100 - product.discount) / 100);
  }

  selectProduct(product: any): void {
    this.dialogRef.close(null);
    this.router.navigate(['/products_details', product.id]);
  }

  viewAll(): void {
    this.dialogRef.close(this.searchName);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
